import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { ButtonGroup } from '@chakra-ui/react';
import React from 'react';
import { createUltimatePagination } from 'react-ultimate-pagination';
import { i18n } from '../../../i18n/translate.js';
import IconButton from '../IconButton/component.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import Button from '../Button/component.js';
var PaginationComponentButton = function PaginationComponentButton(props) {
  var isDisabled = props.isDisabled,
    label = props.label,
    onClick = props.onClick,
    value = props.value;
  return /*#__PURE__*/React.createElement(Button
  // variant="outline"
  , {
    isActive: props.isActive,
    isDisabled: isDisabled,
    onClick: onClick,
    "aria-label": label
  }, value);
};
PaginationComponentButton.displayName = "PaginationComponentButton";
var PaginationComponentPage = function PaginationComponentPage(props) {
  return PaginationComponentButton(props);
};
var PaginationComponentEllipsis = function PaginationComponentEllipsis(props) {
  return PaginationComponentButton(_objectSpread2(_objectSpread2({}, props), {}, {
    isDisabled: true,
    onClick: function onClick() {},
    value: '…',
    label: i18n.t('More')
  }));
};
var PaginationComponentFirstPageLink = function PaginationComponentFirstPageLink(props) {
  return PaginationComponentButton(_objectSpread2(_objectSpread2({}, props), {}, {
    isDisabled: props.isActive,
    isArrowButton: true,
    value: '«',
    label: i18n.t('First')
  }));
};
var PaginationComponentPreviousPageLink = function PaginationComponentPreviousPageLink(props) {
  return /*#__PURE__*/React.createElement(IconButton, {
    ariaLabel: i18n.t('Previous'),
    icon: {
      prefix: 'fas',
      iconName: 'arrow-left'
    },
    variant: "ghost",
    size: "compact",
    isDisabled: props.isActive,
    onClick: props.onClick
  });
};
PaginationComponentPreviousPageLink.displayName = "PaginationComponentPreviousPageLink";
var PaginationComponentNextPageLink = function PaginationComponentNextPageLink(props) {
  return /*#__PURE__*/React.createElement(IconButton, {
    ariaLabel: i18n.t('Next'),
    icon: {
      prefix: 'fas',
      iconName: 'arrow-right'
    },
    variant: "ghost",
    size: "compact",
    isDisabled: props.isActive,
    onClick: props.onClick
  });
};
PaginationComponentNextPageLink.displayName = "PaginationComponentNextPageLink";
var PaginationComponentLastPageLink = function PaginationComponentLastPageLink(props) {
  return PaginationComponentButton(_objectSpread2(_objectSpread2({}, props), {}, {
    isDisabled: props.isActive,
    isArrowButton: true,
    value: '»',
    label: i18n.t('Last')
  }));
};
var PaginationComponentWrapper = function PaginationComponentWrapper(props) {
  // set class name based on pagination component usage
  var className = _formatClassName([props.coreTable ? 'core-pagination' : 'pagination', {
    'pagination-branded': props.isBranded
  }]);
  return /*#__PURE__*/React.createElement(ButtonGroup, {
    className: className,
    variant: 'outline',
    size: 'compact',
    colorScheme: props.isBranded ? 'brand' : 'gray'
  }, props.children);
};
PaginationComponentWrapper.displayName = "PaginationComponentWrapper";
var itemTypeToComponent = {
  PAGE: PaginationComponentPage,
  ELLIPSIS: PaginationComponentEllipsis,
  FIRST_PAGE_LINK: PaginationComponentFirstPageLink,
  PREVIOUS_PAGE_LINK: PaginationComponentPreviousPageLink,
  NEXT_PAGE_LINK: PaginationComponentNextPageLink,
  LAST_PAGE_LINK: PaginationComponentLastPageLink
};
var UltimatePagination = createUltimatePagination({
  itemTypeToComponent: itemTypeToComponent,
  WrapperComponent: PaginationComponentWrapper
});
var PaginationComponent = UltimatePagination;
export { PaginationComponent };